import React from "react";

const Bash_Tar = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Tar</h2>
      <p>Create and extract tar archives (often combined with gzip/bzip2).</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>tar [options] archive.tar[.gz|.bz2] files...</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>tar -czvf archive.tar.gz folder/
tar -xzvf archive.tar.gz</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Common flags: c=create, x=extract, v=verbose, z=gzip.</p>
    </div>
  );
};

export default Bash_Tar;
